import { TFunction } from 'i18next';

export const getRecentlyVisitedLocations = (
  t: TFunction<'translation', undefined>,
) => ({
  limit: 16,
  carouselId: 'recently-visited-locations-carousel',
  desktopCountPerSlide: 4,
  tabletCountPerSlide: 3,
  bigMobileCountPerSlide: 2,
  smallMobileCountPerSlide: 1,
  sectionInfo: t(
    'Quickly jump back into your recently viewed lessons and activities ' +
      'to continue where you left off.',
  ),
});
